import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { obterProcesso } from '../servicos/servicoApiProcessos';

interface Processo {
  id?: string;
  processo_id?: string;
  nome?: string;
  title?: string;
  estado_wizard?: string;
  metadados?: {
    estado_wizard?: string;
    resultado_analise?: unknown;
  };
  status_processamento?: string;
  status?: string;
}

export function ProcessoDetalhe(): JSX.Element {
  const { id } = useParams();
  const navigate = useNavigate();
  const [processo, setProcesso] = useState<Processo | null>(null);
  const [erro, setErro] = useState<string>('');

  useEffect(() => {
    (async () => {
      if (!id) return;
      try {
        const resp = await obterProcesso(id);
        setProcesso(resp.data);
      } catch (err: unknown) {
        console.error('Erro ao obter processo:', err);
        setErro(err instanceof Error ? err.message : 'Falha ao carregar processo');
      }
    })();
  }, [id]);

  if (!id) return <div>Processo inválido</div>;
  // Helper para extrair campos de forma resiliente (suporta formatos com 'id' ou 'processo_id')
  const renderContent = () => {
    if (!processo) return <div>Carregando...</div>;

    const pid = processo.processo_id || processo.id || id;
    const nome = processo.nome || processo.title || '';
    const estado = processo.estado_wizard || (processo.metadados && processo.metadados.estado_wizard) || '';
    const status = processo.status_processamento || '';
    const metadados = processo.metadados || {};

    const handleContinuar = () => {
      const resultado = metadados?.resultado_analise;
      const isDone = (processo?.status_processamento || processo?.status || '').toString().toLowerCase() === 'done' || Boolean(resultado);

      const baseUrl = `/analise-peticao?processo_id=${encodeURIComponent(pid)}`;
      if (isDone) {
        // If already done, navigate and include flag to land on results (frontend will interpret)
        navigate(`${baseUrl}&forcar_resultados=1`);
      } else {
        // Otherwise go to processing/retry page which will resume polling
        navigate(baseUrl);
      }
    };

    return (
      <div>
        <p><strong>ID:</strong> {pid}</p>
        <p><strong>Nome:</strong> {nome}</p>
        <p><strong>Estado Wizard:</strong> {estado}</p>
        <p><strong>Status Processamento:</strong> {status}</p>

        <h3>Metadados</h3>
        <pre style={{ background: '#f6f6f6', padding: 12 }}>{JSON.stringify(metadados, null, 2)}</pre>

        <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
          <button onClick={handleContinuar} className="rounded-md bg-blue-500 px-4 py-2 text-white hover:bg-blue-700">Continuar</button>
          <button onClick={() => window.open(`/analise-peticao?processo_id=${encodeURIComponent(pid)}`, '_blank')} className="rounded-md bg-gray-500 px-4 py-2 text-white hover:bg-gray-700">Abrir em nova aba</button>
        </div>
      </div>
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <h1>Detalhes do Processo</h1>
      {erro && <div style={{ color: 'red' }}>{erro}</div>}
      {renderContent()}
    </div>
  );
}

export default ProcessoDetalhe;
